// extracted by mini-css-extract-plugin
module.exports = {"s10":"samsungcases-module--s10--31gpG","s20":"samsungcases-module--s20--cfm1m","s21":"samsungcases-module--s21--KoGBR","breadcrumb":"samsungcases-module--breadcrumb--2x_Yb"};